import { BasicValueUnitGetModuleFactory } from '../../endpoints/basic/valueUnit/get.module.js';
import '../../endpoints/index/constituents/list.module.js';
import { InstrumentGetByNotationModuleFactory } from '../../endpoints/instrument/getByNotation.module.js';
import '../../endpoints/instrument/crossreference.module.js';
import '../../endpoints/instrument/coupon/keyData/get.module.js';
import '../../endpoints/instrument/exchangeRate/getByISOCode.module.js';
import '../../endpoints/notation/crossReference/listByInstrument.module.js';
import '../../endpoints/notation/keyFigures/get.module.js';
import { NotationGetModuleFactory } from '../../endpoints/notation/get.module.js';
import '../../endpoints/prices/list.module.js';
import { DebtInstrumentGetModuleFactory } from '../../endpoints/debtInstrument/get.module.js';
import '../../endpoints/legalEntity/company/get.module.js';
import '../../endpoints/legalEntity/address/list.module.js';
import '../../endpoints/news/article/get.module.js';
import '../../endpoints/news/article/searchByText.module.js';
import '../../endpoints/fund/shareClass/get.module.js';
import '../../endpoints/instrument/benchmark/list.module.js';
import '../../endpoints/prices/bidAsk/list.module.js';
import { SecuritizedDerivativeGetModuleFactory } from '../../endpoints/securitizedDerivative/get.module.js';
import '../../endpoints/company/keyItems/fiscalYear/listByInstrument.module.js';
import '../../endpoints/instrument/category/list.module.js';
import '../../endpoints/securitizedDerivative/keyFigures/notation/get.module.js';
import '../../endpoints/notation/searchByText.module.js';
import '../../endpoints/prices/timeSeries/eod/list.module.js';
import '../../endpoints/prices/timeSeries/intraday/subsample/list.module.js';
import '../../endpoints/company/board/listByInstrument.module.js';
import '../../endpoints/prices/orderbook/aggregated/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/get.module.js';
import '../../endpoints/company/estimates/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/benchmark/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/type/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/performance/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/fee/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/manager/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/riskFigures/listByInstrument.module.js';
import '../../endpoints/stock/owner/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/evaluation/getByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/holding/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/eod/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/intraday/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/type/list.module.js';
import '../../endpoints/securitizedDerivative/notation/screener/search.module.js';
import '../../endpoints/basic/market/list.module.js';
import '../../endpoints/basic/language/list.module.js';
import '../../endpoints/basic/valueUnit/currency/main/list.module.js';
import '../../endpoints/basic/frequency/type/list.module.js';
import '../../endpoints/legalEntity/list.module.js';
import '../../endpoints/instrument/coupon/interestRate/type/list.module.js';
import '../../endpoints/instrument/backgroundText/listByInstrument.module.js';
import '../../endpoints/stock/recommendation/aggregate/history/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/investmentFocus/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/exchange/list.module.js';
import '../../endpoints/stock/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/status/get.module.js';
import '../../endpoints/instrument/complianceProperty/listByInstrument.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/list.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/get.module.js';
import '../../endpoints/calendarEvent/list.module.js';
import '../../endpoints/calendarEvent/get.module.js';
import '../../endpoints/stock/notation/screener/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/figure/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/ranking/listByInstrument.module.js';
import '../../endpoints/news/article/listByMediaKind.module.js';
import '../../endpoints/documents/searchByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/narrative/get.module.js';
import '../../endpoints/debtInstrument/keyFigures/notation/get.module.js';
import '../../endpoints/securitizedDerivative/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/keyFigures/list.module.js';
import '../../endpoints/instrument/legalEntity/backgroundText/listByInstrument.module.js';
import '../../endpoints/securitizedDerivative/underlying/list.module.js';
import '../../endpoints/basic/market/get.module.js';
import '../../endpoints/securitizedDerivative/issuer/search.module.js';
import '../../endpoints/prices/tradingSchedule/event/list.module.js';
import '../../endpoints/debtInstrument/issuer/search.module.js';
import '../../endpoints/debtInstrument/notation/screener/search.module.js';
import '../../endpoints/watchlist/create.module.js';
import '../../endpoints/watchlist/delete.module.js';
import '../../endpoints/watchlist/list.module.js';
import '../../endpoints/watchlist/get.module.js';
import '../../endpoints/watchlist/modify.module.js';
import '../../endpoints/watchlist/position/create.module.js';
import '../../endpoints/watchlist/position/delete.module.js';
import '../../endpoints/watchlist/position/list.module.js';
import '../../endpoints/watchlist/position/get.module.js';
import '../../endpoints/watchlist/position/modify.module.js';
import '../../endpoints/basic/region/list.module.js';
import { PortfolioTransactionListModuleFactory } from '../../endpoints/portfolio/transaction/list.module.js';
import { PortfolioListModuleFactory } from '../../endpoints/portfolio/list.module.js';
import '../../endpoints/portfolio/position/list.module.js';
import { PortfolioGetModuleFactory } from '../../endpoints/portfolio/get.module.js';
import '../../endpoints/portfolio/create.module.js';
import '../../endpoints/portfolio/modify.module.js';
import '../../endpoints/portfolio/delete.module.js';
import '../../endpoints/portfolio/transaction/create.module.js';
import '../../endpoints/portfolio/transaction/delete.module.js';
import { PortfolioTransactionModifyModuleFactory } from '../../endpoints/portfolio/transaction/modify.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/screener/search.module.js';
import '../../endpoints/basic/region/country/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/element/list.module.js';
import '../../endpoints/instrument/get.module.js';
import '../../endpoints/portfolio/evaluation/list.module.js';
import '../../endpoints/stock/recommendation/aggregate/get.module.js';
import '../../endpoints/prices/timeSeries/eod/subsample/get.module.js';
import '../../endpoints/category/listBySystem.module.js';
import '../../endpoints/alerting/prices/basic/alert/get.module.js';
import '../../endpoints/alerting/prices/basic/alert/list.module.js';
import '../../endpoints/alerting/prices/basic/alert/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/create.module.js';
import '../../endpoints/alerting/prices/basic/trigger/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/get.module.js';
import '../../endpoints/alerting/prices/basic/trigger/list.module.js';
import '../../endpoints/alerting/prices/basic/trigger/modify.module.js';
import '../../endpoints/company/logo/get.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/assetClass/list.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/sector/list.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/managers/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/benchmarkDetails/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/summary/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/classifications/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/costsFees/get.module.js';
import '../../endpoints/factset/content/factsetOwnership/v1/fundHoldings/get.module.js';
import '../../endpoints/fund/holding/listByInstrument.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/returnsSnapshot/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScores/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScoresAll/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/annualizedTotalReturn/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/cumulativeTotalReturn/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/esg/getByInstrument.module.js';
import '../../endpoints/fund/breakdown/position/ListByInstrument.module.js';
import '../../endpoints/product/widgets/portfolio/holdings/list.module.js';
import '../../endpoints/product/widgets/portfolio/weights/list.module.js';
import '../../endpoints/product/widgets/portfolio/characteristics/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/attribution/list.module.js';
import '../../endpoints/notation/crossReference/listBySymbol.module.js';
import '../../endpoints/notation/crossReference/listByISIN.module.js';
import '../../endpoints/instrument/notation/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/countries/get.module.js';
import '../../endpoints/news/article/type/list.module.js';
import '../../endpoints/news/publisher/list.module.js';
import '../../endpoints/category/system/list.module.js';
import '../../endpoints/news/distributor/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/regions/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/discreteTotalReturn/list.module.js';
import '../../endpoints/index/get.module.js';
import '../../endpoints/fund/notation/screener/search.module.js';
import '../../endpoints/basic/valueUnit/list.module.js';
import '../../endpoints/fund/issuer/search.module.js';
import '../../endpoints/rating/grade/listBySystem.module.js';
import '../../endpoints/fund/notation/screener/valueRanges/get.module.js';
import { getLanguage, mapAssetClass, convertMdg2DateTimeResponse, getPercentage, inheritEndpointOptions, getEndpointOptions } from '../../helpers/common.js';
import 'lodash.set';
import { FactsheetHeaderStoreModuleFactory } from '../factsheet-header/index.module.js';
import { Mdg2StoreModuleFactory } from '../../abstracts/Mdg2StoreModuleFactory.js';
import '../../abstracts/Mdg2EndpointStoreModuleFactory.js';
import '../../abstracts/Mdg2SubscriptionStoreModuleFactory.js';
import 'vue';
import 'lodash.matches';
import { formatISO } from 'date-fns';

var _a, _b, _c, _d, _e, _f, _g, _h;
class PortfolioTransactionEditStoreModuleFactory extends Mdg2StoreModuleFactory {
  constructor() {
    super(...arguments);
    this.defaultNameType = "name";
    this.defaultFallbackForNameType = true;
    this.nameType = (_d = (_c = (_b = (_a = this.options) == null ? void 0 : _a.instrument) == null ? void 0 : _b.name) == null ? void 0 : _c.type) != null ? _d : this.defaultNameType;
    this.isNameTypeFallbackEnabled = (_h = (_g = (_f = (_e = this.options) == null ? void 0 : _e.instrument) == null ? void 0 : _f.name) == null ? void 0 : _g.fallback) != null ? _h : this.defaultFallbackForNameType;
    this.defaultLanguage = "en";
    this.buyDateValidationPattern = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/;
    this.buyPriceValidationPattern = /^\d+(\.\d+)?$/;
    this.exchangeRateValidationPattern = /^\d+(\.\d+)?$/;
    this.quantityValidationPattern = /^\d+$/;
    this.transactionListPaginationLimit = 500;
    this.percentCurrencyId = 258;
  }
  getPortfolioGetRequest(id) {
    return { id };
  }
  getPortfolioGetData(payload) {
    var _a2;
    const request = this.getPortfolioGetRequest(payload.id);
    const response = this.getEndpoints().portfolioGet.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  getPortfolioTransactionListRequest(id) {
    return { id, _paginationLimit: this.transactionListPaginationLimit };
  }
  getPortfolioTransactionListData(payload) {
    var _a2;
    const request = this.getPortfolioTransactionListRequest(payload.id);
    const response = this.getEndpoints().portfolioTransactionList.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  getSelectedTransaction(payload) {
    const portfolioTransactionListData = this.getPortfolioTransactionListData(payload);
    const selectedTransaction = portfolioTransactionListData == null ? void 0 : portfolioTransactionListData.find((transaction) => {
      return transaction.notation.id === payload.securityId && transaction.id === payload.transactionId;
    });
    return selectedTransaction != null ? selectedTransaction : null;
  }
  getSelectedTransactionNotationId(payload) {
    const selectedTransaction = this.getSelectedTransaction(payload);
    if (!(selectedTransaction == null ? void 0 : selectedTransaction.notation.id)) {
      throw new Error("Could not get notation id");
    }
    return selectedTransaction.notation.id;
  }
  getInstrumentGetByNotationRequest(id, payloadLanguage) {
    return { id, _language: getLanguage(payloadLanguage, this.defaultLanguage, this.options) };
  }
  getInstrumentGetByNotationData(payload) {
    var _a2;
    try {
      const notationId = this.getSelectedTransactionNotationId(payload);
      const request = this.getInstrumentGetByNotationRequest(notationId, payload.language);
      const response = this.getEndpoints().instrumentGetByNotation.getData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (error) {
      return null;
    }
  }
  getNotationGetRequest(id, payloadLanguage) {
    return {
      identifier: id,
      identifierType: "idNotation",
      _language: getLanguage(payloadLanguage, this.defaultLanguage, this.options)
    };
  }
  getNotationGetData(payload) {
    var _a2;
    try {
      const notationId = this.getSelectedTransactionNotationId(payload);
      const request = this.getNotationGetRequest(notationId, payload.language);
      const response = this.getEndpoints().notationGet.getData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (error) {
      return null;
    }
  }
  getAssetClass(payload) {
    const instrumentData = this.getInstrumentGetByNotationData(payload);
    return mapAssetClass(instrumentData == null ? void 0 : instrumentData.assetClass.code);
  }
  getDebtInstrumentGetRequest(identifier, payloadLanguage) {
    return { identifier, identifierType: "idNotation", _language: getLanguage(payloadLanguage, this.defaultLanguage, this.options) };
  }
  getDebtInstrumentGetData(payload) {
    var _a2;
    const request = this.getDebtInstrumentGetRequest(payload.securityId, payload.language);
    const response = this.getEndpoints().debtInstrumentGet.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  getResponseData(payload) {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i, _j, _k, _l, _m, _n;
    const portfolioGetData = this.getPortfolioGetData(payload);
    const selectedTransaction = this.getSelectedTransaction(payload);
    const instrumentData = this.getInstrumentGetByNotationData(payload);
    const notationData = this.getNotationGetData(payload);
    const assetClass = this.getAssetClass(payload);
    const securityCurrency = this.getSecurityCurrency(payload);
    const currencyIsPercent = (notationData == null ? void 0 : notationData.valueUnit.id) === this.percentCurrencyId;
    const nameFallback = this.isNameTypeFallbackEnabled ? (_a2 = instrumentData == null ? void 0 : instrumentData.name) != null ? _a2 : null : null;
    return {
      portfolio: {
        id: payload.id,
        name: (_b2 = portfolioGetData == null ? void 0 : portfolioGetData.name) != null ? _b2 : null,
        currency: (_c2 = portfolioGetData == null ? void 0 : portfolioGetData.currency.isoCode) != null ? _c2 : null
      },
      transaction: {
        id: (_d2 = selectedTransaction == null ? void 0 : selectedTransaction.id) != null ? _d2 : null,
        securityId: (_e2 = selectedTransaction == null ? void 0 : selectedTransaction.notation.id) != null ? _e2 : null,
        currency: (_g2 = (_f2 = notationData == null ? void 0 : notationData.valueUnit.isoCode) != null ? _f2 : notationData == null ? void 0 : notationData.valueUnit.code) != null ? _g2 : null,
        currencyIsPercent,
        name: (_h2 = instrumentData == null ? void 0 : instrumentData[this.nameType]) != null ? _h2 : nameFallback,
        isin: (_i = instrumentData == null ? void 0 : instrumentData.isin) != null ? _i : null,
        assetClass,
        transactionType: selectedTransaction == null ? void 0 : selectedTransaction.type,
        quantity: (_j = selectedTransaction == null ? void 0 : selectedTransaction.numberShares) != null ? _j : null,
        exchangeRate: (_k = selectedTransaction == null ? void 0 : selectedTransaction.exchangeRate) != null ? _k : null,
        buy: {
          price: (_l = selectedTransaction == null ? void 0 : selectedTransaction.price) != null ? _l : null,
          date: convertMdg2DateTimeResponse((_m = selectedTransaction == null ? void 0 : selectedTransaction.time) != null ? _m : null),
          valueInPortfolioCurrency: (selectedTransaction == null ? void 0 : selectedTransaction.price) && currencyIsPercent ? getPercentage(selectedTransaction.price) : (_n = selectedTransaction == null ? void 0 : selectedTransaction.price) != null ? _n : null,
          currency: securityCurrency
        }
      }
    };
  }
  getResponseMeta(payload) {
    return {
      validationRules: {
        buyDate: { pattern: this.buyDateValidationPattern },
        buyPrice: { pattern: this.buyPriceValidationPattern },
        exchangeRate: { pattern: this.exchangeRateValidationPattern },
        quantity: { pattern: this.quantityValidationPattern }
      }
    };
  }
  getResponse(payload) {
    return {
      data: this.getResponseData(payload),
      meta: this.getResponseMeta(payload)
    };
  }
  getPortfolioTransactionModifyRequest(payload) {
    return {
      data: {
        id: payload.id,
        transaction: {
          id: payload.transactionId,
          notation: {
            id: payload.securityId
          },
          time: formatISO(payload.buyDate),
          numberShares: payload.quantity,
          price: payload.buyPrice,
          exchangeRate: payload.exchangeRate
        }
      }
    };
  }
  async updatePortfolioTransactionModify(payload) {
    const request = this.getPortfolioTransactionModifyRequest(payload);
    return this.getEndpoints().portfolioTransactionModify.updateState(request);
  }
  async updatePortfolioTransactionList(payload) {
    const request = this.getPortfolioTransactionListRequest(payload.id);
    return this.getEndpoints().portfolioTransactionList.updateState(request);
  }
  async updatePortfolioGet(payload) {
    const request = this.getPortfolioGetRequest(payload.id);
    return this.getEndpoints().portfolioGet.updateState(request);
  }
  getPortfolioListRequest() {
    return {};
  }
  async updatePortfolioList(payload) {
    const request = this.getPortfolioListRequest();
    return this.getEndpoints().portfolioList.updateState(request);
  }
  async updateInstrumentGetByNotation(payload) {
    try {
      await this.updatePortfolioTransactionList(payload);
      const transactionNotationId = this.getSelectedTransactionNotationId(payload);
      const request = this.getInstrumentGetByNotationRequest(transactionNotationId, payload.language);
      return this.getEndpoints().instrumentGetByNotation.updateState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  async updateNotationGet(payload) {
    try {
      await this.updatePortfolioTransactionList(payload);
      const transactionNotationId = this.getSelectedTransactionNotationId(payload);
      const request = this.getNotationGetRequest(transactionNotationId, payload.language);
      return this.getEndpoints().notationGet.updateState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  async updateDebtInstrumentGet(payload) {
    const request = this.getDebtInstrumentGetRequest(payload.securityId, payload.language);
    return this.getEndpoints().debtInstrumentGet.updateState(request);
  }
  async updateComponentsInputs(payload) {
    let isResponseSuccessful = true;
    try {
      switch (payload.action) {
        case "EDIT": {
          await this.updatePortfolioTransactionModify(payload);
          await Promise.all([this.updatePortfolioTransactionList(payload), this.updatePortfolioGet(payload), this.updatePortfolioList(payload)]);
          break;
        }
        case "FETCH":
        default: {
          await Promise.all([this.updatePortfolioTransactionList(payload), this.updatePortfolioGet(payload)]);
          await Promise.all([this.updateInstrumentGetByNotation(payload), this.updateNotationGet(payload)]);
          await this.updateSecurityCurrency(payload);
          break;
        }
      }
    } catch (error) {
      isResponseSuccessful = false;
      this.logger.error(error);
    }
    return isResponseSuccessful;
  }
  async updateSecurityCurrency(payload) {
    await this.updateInstrumentGetByNotation(payload);
    const assetClass = this.getAssetClass(payload);
    if (assetClass === "bond") {
      return this.updateBondIssueCurrency(payload);
    }
    if (this.isDerivative(assetClass)) {
      return this.updateDerivativeCurrency(payload);
    }
    return true;
  }
  async updateBondIssueCurrency(payload) {
    return this.updateDebtInstrumentGet(payload);
  }
  async updateDerivativeCurrency(payload) {
    await this.updateNotationGet(payload);
    const notationData = this.getNotationGetData(payload);
    if ((notationData == null ? void 0 : notationData.valueUnit.id) === this.percentCurrencyId) {
      return this.updateDerivativeNominalCurrency(payload);
    }
    return true;
  }
  async updateDerivativeNominalCurrency(payload) {
    await this.updateSecuritizedDerivativeGet(payload);
    const securitizedDerivativeData = this.getSecuritizedDerivativeData(payload);
    if (!(securitizedDerivativeData == null ? void 0 : securitizedDerivativeData.nominal.currency.id)) {
      return false;
    }
    return this.updateBasicValueUnitGet(payload, securitizedDerivativeData.nominal.currency.id);
  }
  getSecurityCurrency(payload) {
    var _a2, _b2, _c2;
    const assetClass = this.getAssetClass(payload);
    if (assetClass === "bond") {
      const debtInstrumentData = this.getDebtInstrumentGetData(payload);
      return (_a2 = debtInstrumentData == null ? void 0 : debtInstrumentData.issue.price.valueUnit.code) != null ? _a2 : null;
    }
    const notationData = this.getNotationGetData(payload);
    if (this.isDerivative(assetClass) && (notationData == null ? void 0 : notationData.valueUnit.id) === this.percentCurrencyId) {
      const securitizedDerivativeData = this.getSecuritizedDerivativeData(payload);
      const nominalValueUnitData = (securitizedDerivativeData == null ? void 0 : securitizedDerivativeData.nominal.currency.id) ? this.getBasicValueUnitGetData(payload, securitizedDerivativeData.nominal.currency.id) : null;
      return (_b2 = nominalValueUnitData == null ? void 0 : nominalValueUnitData.code) != null ? _b2 : null;
    }
    return (_c2 = notationData == null ? void 0 : notationData.valueUnit.code) != null ? _c2 : null;
  }
  isDerivative(assetClass) {
    return ["investmentProduct", "interestRate", "leveragedProduct", "option"].includes(assetClass);
  }
  async cleanUp(payload) {
    return Promise.resolve(true);
  }
  getDependencies() {
    var _a2, _b2;
    if (!this.dependencies) {
      const endpointConfiguration = (_a2 = this.options) == null ? void 0 : _a2.endpointConfiguration;
      const genericAdditionalData = ["isin", "wkn", "country"];
      const factsheetHeader = new FactsheetHeaderStoreModuleFactory({
        mdg2Client: this.mdg2Client,
        logger: this.logger,
        store: this.store,
        options: {
          assetClass: {
            generic: {
              additionalData: genericAdditionalData
            }
          },
          ...inheritEndpointOptions(endpointConfiguration, (_b2 = this.options) == null ? void 0 : _b2.factsheetHeader)
        }
      });
      this.dependencies = { factsheetHeader };
    }
    return this.dependencies;
  }
  getEndpoints() {
    var _a2;
    if (!this.endpoints) {
      const endpointConfiguration = (_a2 = this.options) == null ? void 0 : _a2.endpointConfiguration;
      this.endpoints = {
        instrumentGetByNotation: this.getModuleEntity(InstrumentGetByNotationModuleFactory, getEndpointOptions(endpointConfiguration, "instrumentGetByNotation")),
        portfolioGet: this.getModuleEntity(PortfolioGetModuleFactory, getEndpointOptions(endpointConfiguration, "portfolioGet")),
        portfolioList: this.getModuleEntity(PortfolioListModuleFactory, getEndpointOptions(endpointConfiguration, "portfolioList")),
        portfolioTransactionList: this.getModuleEntity(PortfolioTransactionListModuleFactory, getEndpointOptions(endpointConfiguration, "portfolioTransactionList")),
        portfolioTransactionModify: this.getModuleEntity(PortfolioTransactionModifyModuleFactory, getEndpointOptions(endpointConfiguration, "portfolioTransactionModify")),
        notationGet: this.getModuleEntity(NotationGetModuleFactory, getEndpointOptions(endpointConfiguration, "notationGet")),
        debtInstrumentGet: this.getModuleEntity(DebtInstrumentGetModuleFactory, getEndpointOptions(endpointConfiguration, "debtInstrumentGet")),
        securitizedDerivativeGet: this.getModuleEntity(SecuritizedDerivativeGetModuleFactory, getEndpointOptions(endpointConfiguration, "securitizedDerivativeGet")),
        basicValueUnitGet: this.getModuleEntity(BasicValueUnitGetModuleFactory, getEndpointOptions(endpointConfiguration, "basicValueUnitGet"))
      };
    }
    return this.endpoints;
  }
  getSecuritizedDerivativeGetRequest(id, payloadLanguage) {
    const language = getLanguage(payloadLanguage, this.defaultLanguage, this.options);
    return { id, _language: language };
  }
  getSecuritizedDerivativeData(payload) {
    var _a2;
    const idInstrument = this.getIdInstrument(payload);
    const request = this.getSecuritizedDerivativeGetRequest(idInstrument, payload.language);
    const response = this.getEndpoints().securitizedDerivativeGet.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  async updateSecuritizedDerivativeGet(payload) {
    await this.updateInstrumentGetByNotation(payload);
    const idInstrument = this.getIdInstrument(payload);
    const request = this.getSecuritizedDerivativeGetRequest(idInstrument, payload.language);
    return this.getEndpoints().securitizedDerivativeGet.updateState(request);
  }
  getIdInstrument(payload) {
    const instrumentData = this.getInstrumentGetByNotationData(payload);
    if (!(instrumentData == null ? void 0 : instrumentData.id)) {
      throw new Error("Could not get instrument id");
    }
    return instrumentData.id;
  }
  getBasicValueUnitGetRequest(id) {
    return { id };
  }
  getBasicValueUnitGetData(payload, valueUnitId) {
    var _a2;
    const request = this.getBasicValueUnitGetRequest(valueUnitId);
    const response = this.getEndpoints().basicValueUnitGet.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  async updateBasicValueUnitGet(payload, valueUnitId) {
    try {
      const request = this.getBasicValueUnitGetRequest(valueUnitId);
      return this.getEndpoints().basicValueUnitGet.updateState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
}

export { PortfolioTransactionEditStoreModuleFactory };
